export enum CoverageSplitStatus {
  RUNNING = "running",
  DRAFT = "draft",
  CONCLUDED = "concluded",
}

/**
 * A draft was never started. Concluded means the test was stopped; it does not
 * mean a winner was recorded.
 */
export function coverageSplitStatus({
  active,
  endDate,
}: {
  active?: boolean | null;
  endDate?: Date | null;
}): CoverageSplitStatus {
  if (active) {
    return CoverageSplitStatus.RUNNING;
  }
  return endDate ? CoverageSplitStatus.CONCLUDED : CoverageSplitStatus.DRAFT;
}
